import React, { useEffect, useState } from "react"; 
import { Button, TextField, Select, MenuItem, FormControl, InputLabel, Typography } from '@mui/material';
import axios from 'axios';
import "../../cssfiles/homepage.css";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LK_Delete from '../../images/LK_Delete';
import CustomCancelButton from '../CommonComponents/CustomCancelButton';
import CustomActionButton from "../CommonComponents/CustomActionButton";
import CustomDialogBox from "../CommonComponents/CustomDialogBox";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    
  } from '@mui/material';
import { useSelector } from "react-redux";
import { getCheckListMaintenance } from '../../Restclient/datacollection';

function generateCustomUUID() { 
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) { 
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8); 
        return v.toString(16); 
    }); 
} 

const Questionnaire = React.memo(({ onSubmitTemplate, selectedType,template , setClickedHandleSubmit, clickedHandleSubmit}) => {
  const [questions, setQuestions] = useState([{  CheckListItemID:generateCustomUUID(), description: 'Maintenance Completed', responseType: 'Yes/No', options: [] }]);
  const [qnasubmitted, setQnasubmitted] = useState(false);
  const [openQuestionLimitDialog, setOpenQuestionLimitDialog] = useState(false);
  // Dialog state for option limit
  const [openOptionLimitDialog, setOpenOptionLimitDialog] = useState(false);
  const handleOpenOptionLimitDialogClose = () => setOpenOptionLimitDialog(false);
      

  const handleOpenQuestionLimitDialogClose = () => setOpenQuestionLimitDialog(false);
  const themechange = useSelector((state) => state.themedata.theme)
  const handleAddQuestion = () => {
    if (questions.length >= 10) {
      setOpenQuestionLimitDialog(true);
      return;
    }
    console.log("handleAddQuestion maintenance",questions)
    setQuestions([...questions, { CheckListItemID: generateCustomUUID(), description: '', responseType: '', options: [] }]);
  };
  const [openAtLeastOneConditionDialog, setopenAtLeastOneConditionDialog] = useState(false);
  const [errordropdown, setErrorDropdown] = useState(false);
  const getCheckListMaintenancecallback = (res) => {
          console.log("getCheckListMaintenancecallback",res,"res?.data?.checkListMaintenance.length",res?.data?.checkListMaintenance.length)
          if(res!= undefined && res?.data?.checkListMaintenance != undefined && res?.data?.checkListMaintenance.length > 0){
            setQuestions(res?.data?.checkListMaintenance)
          }else if(res?.data?.checkListMaintenance.length == 0){
            setQuestions([{  CheckListItemID:generateCustomUUID(), description: 'Maintenance Completed', responseType: 'Yes/No', options: [] }])
          }
          
      }

  useEffect(() => {
    if(!clickedHandleSubmit){
        getCheckListMaintenance(selectedType, getCheckListMaintenancecallback)
    }else{
        setQuestions(template)
    }
    
  },[selectedType])

  const handleRemoveQuestion = (index) => {
    if(questions.length == 1 && index==0){
      setopenAtLeastOneConditionDialog(true)
      return;
   }

    const updatedQuestions = questions.filter((q, i) => i !== index);
    setQuestions(updatedQuestions);
  };

  const handleInputChange = (index, field, value) => {
    const updatedQuestions = questions.map((q, i) =>
      i === index ? { ...q, [field]: value } : q
    );
    setQuestions(updatedQuestions);
    setErrorDropdown(false);
  };

  const handleCloseAtLeastOneConditionDialog = () => {
    console.log("handleCloseAtLeastOneConditionDialog")
    setopenAtLeastOneConditionDialog(false)
  }

  const handleConfirmationAtLeastOneConditionDialog = () => {
    console.log("handleConfirmationAtLeastOneConditionDialog")
    setopenAtLeastOneConditionDialog(false)
  }
  const handleBlur = (arg) => {
    if(!arg){
        setErrorDropdown(true);
    }
  };

  const handleAddOption = (index) => {
    if (Array.isArray(questions[index].options) && questions[index].options.length>0 && questions[index].options.length >= 5) {
      setOpenOptionLimitDialog(true);
      return;
    }
    const updatedQuestions = questions.map((q, i) => {
      if (i === index) {
        return { ...q, options: [...q.options, ''] };
      }
      return q;
    });
    setQuestions(updatedQuestions);
  };

  const handleRemoveOption = (qIndex, oIndex) => {
    const updatedQuestions = questions.map((q, i) => {
      if (i === qIndex) {
        const updatedOptions = q.options.filter((opt, j) => j !== oIndex);
        return { ...q, options: updatedOptions };
      }
      return q;
    });
    setQuestions(updatedQuestions);
  };

  function handleCloseQnA() {
    setQnasubmitted(false);
  }

  const handleOptionChange = (qIndex, oIndex, value) => {
    const updatedQuestions = questions.map((q, i) => {
      if (i === qIndex) {
        const updatedOptions = q.options.map((opt, j) =>
          j === oIndex ? value : opt
        );
        return { ...q, options: updatedOptions };
      }
      return q;
    });
    setQuestions(updatedQuestions);
  };

  function isValidLength(value, minLength, maxLength){
      return value.length >= minLength && value.length <= maxLength;
  }

  function containsSpacesOrSpecialChars(str) {
    return /[\s\W]/.test(str);
  }

  const handleSubmit = () => {
    // template to the parent component
    console.log("handleSubmit maintenance -questions",questions)
    onSubmitTemplate(questions); 
    setQnasubmitted(true);
    setClickedHandleSubmit(true);
    //alert('Questionnaire template submitted!');
  };

  return (
    <div style={{boxSizing:'border-box', width:"100%", marginLeft:'10px',marginRight:'10px'}}>
         <div style={{display:"flex", flexDirection:"row", alignItems:"baseline"}}>
            <div><Typography sx={{fontSize:"16px", marginTop: '10px',fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, textAlign:"left"}}>Create SOP Template for Maintenance Task<span style={{ color: '#DC272D', marginLeft: "5px" }}>*</span></Typography></div>
            <div style={{flex:1}}></div>
            <div>
                <Button sx={{ outline:'none !important',boxShadow:'none', height:'35px', width:'250px',fontSize: '16px',textTransform:'capitalize', marginTop:"10px",marginRight:"15px",backgroundColor:"#005C8E", borderRadius:"20px"}} variant="contained" onClick={handleSubmit}>
                    Add SOP Template to Save
                </Button>
            </div>
        </div>
        <div style={{ display:'flex',flexDirection:'column',marginTop: '0px', marginLeft:"0px", alignItems:'baseline', width:"100%" }}>
            <div style={{marginTop:"0px", marginLeft:"0px"}}>
                <CustomActionButton buttonText={'Add SOP QnA Format'} onClick={handleAddQuestion} />
            </div>
            {questions.map((question, index) => (
              <div key={index}>
                  <div style={{ display:'flex',flexDirection:'row',marginTop: '0px', alignItems:'baseline',gap:"40px" }}>
                    <div style={{display:"flex", flexDirection:"row", alignItems:"baseline", gap:"20px"}}>
                        <Typography sx={{fontSize:"15px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400}}>Question Description</Typography>
                        <TextField
                          label=""
                          variant="standard"
                          value={question.description}
                          onChange={(e) => handleInputChange(index, 'description', e.target.value)}
                          inputProps={{ minLength:5, maxLength: 30, }}
                          helperText={question.description.length>0 && !isValidLength(question.description,5,30) ? `Length must be between 5 and 30 with no special characters allowed. ${question.description.length}/30 characters used` : `${question.description.length}/30 characters used`}
                          FormHelperTextProps={{
                            sx : { color: !isValidLength(question.description,5,30) ? '#DC272D' : '#00943D' }
                          }}
                          sx={{
                            width: '200px',
                            '& .MuiInputBase-input:focus': {
                                color: '#008CD7',
                            },
                            '& .MuiInputBase-root': {
                                fontFamily: 'Roboto',
                                fontSize: '16px',
                                fontWeight: '700',
                                color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                            },
                            '& .MuiInput-root .MuiInputBase-input': {
                                
                            },
                            '& .MuiInputBase-root::before': {
                                borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                            },
                            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                borderBottom: '2px solid #008CD7',
                            },
                            '& .MuiInputBase-root::after': {
                                borderBottom: '2px solid #008CD7',
            
                            },
                        }}
                        />
                    </div>
                    
                    <div style={{display:"flex", flexDirection:"row", alignItems:"baseline", gap:"20px"}}>
                        <Typography sx={{fontSize:"15px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400}}>Expected Response Format</Typography>
                        <FormControl variant="standard" sx={{ marginLeft:"0px", minWidth: 50 }}>
                          <Select

                              labelId="demo-simple-select-standard-label"
                              id="demo-simple-select-standard"
                              IconComponent={KeyboardArrowDownIcon}
                              sx={{
                                "&:before": {
                                borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`  
                                },
                                "&:hover:not(.Mui-disabled):before": {
                                    borderBottom: '2px solid #008CD7',
                                },
                                "&:after": {
                                    borderBottom: '2px solid #008CD7',
                                },
                                margin: 0,
                                padding: 0,
                                width: '200px',
                                fontSize: "18px",
                                fontFamily: "Roboto",
                                fontWeight: '700 !important',
                                color: 'var(--PrimaryText)',
                                '& .MuiInputBase-input': {
                                    paddingLeft: 0
                                },
                                '& .MuiInputBase-input:focus': {
                                    color: 'var(--HighlightedText_Stroke)',
                                    borderBottom: '2px solid var(--HighlightedText_Stroke)',
                                    backgroundColor: 'transparent',
                                    fontWeight: '700 !important',
                                    '& .MuiSvgIcon-root': {
                                        color: 'var(--HighlightedText_Stroke) !important'
                                    },
                                },
                                '& .MuiInputBase-input:focus .MuiSvgIcon-root': {
                                    color: 'var(--HighlightedText_Stroke)',       //not working
                                },
                                '& .MuiSvgIcon-root': {
                                    color: 'var(--PrimaryText)'
                                },
                                '& .MuiNativeSelect-select': {
                                    paddingTop: 0,
                                    paddingBottom: 0,
                                },
                                '& .MuiNativeSelect-select option': {
                                    backgroundColor: 'var(--dropdown-bg) !important',
                                    fontSize: "18px",
                                    fontFamily: "Roboto",
                                    fontWeight: 400,
                                    color: 'var(--PrimaryText) !important',
                                    borderBottom: '2px solid var(--HighlightedText_Stroke)',  //not working
                                },
                                '& .MuiNativeSelect-select option:checked': {
                                    backgroundColor: 'var(--dropdown-bg) !important',
                                    color: 'var(--White) !important',
                                    fontWeight: '700 !important',
                                    borderColor: '2px solid var(--HighlightedText_Stroke)'
                                },
                                '& .MuiInputBase-input option:hover': {
                                    backgroundColor: '#005D8F !important',
                                },
                
                            }}
                            MenuProps={{
                                PaperProps:{
                                    sx:{
                                        width:"100px",
                                        bgcolor:themechange==='dark'?'#3C3C3C':'#C1C1C1',
                                        borderBottom:'2px solid #008CD7',
                                        borderRadius:0,
                                        boxShadow:'none',
                                        maxHeight:'250px',
                                        overflow:'auto',
                                        color:themechange==='dark'?'#FFFFFF':'#3C3C3C',
                                    }
                                },               
                            }}
                          
                            value={question.responseType}
                            onChange={(e) => handleInputChange(index, 'responseType', e.target.value)}
                            label="Response Type"
                          >
                            <MenuItem value="Yes/No">Yes/No</MenuItem>
                            <MenuItem value="Multiple Choice">Multiple Choice</MenuItem>
                            <MenuItem value="Descriptive">Descriptive</MenuItem>
                          </Select>
                          {(question.responseType=='') && <Typography sx={{fontSize:"12px",fontFamily:"Roboto",color:'#DC272D',fontWeight: 400}}>Please select a response format</Typography>}
                        </FormControl>
                    </div>
                    
                    <div>
                        <Button sx={{ width:"20px",height:"20px",padding:"0px",margin:"0px",fontSize:"16px",fontFamily:"Roboto",textTransform:'capitalize', backgroundColor:"var(--SecondaryBackground)", borderRadius:"20px", boxShadow: "none"}} variant="text" onClick={() => handleRemoveQuestion(index)} disableTouchRipple elevation={0}><LK_Delete color={"#005C8E"} width={"20px"} height={"20px"}/></Button>
                    </div>
                    
                  </div>
                  <div style={{display:"flex", flexDirection:"column", alignItems:"baseline"}}>
                        {question.responseType === 'Multiple Choice' && (
                          
                          <div style={{marginLeft:"0px"}}>
                          <div style={{ display: 'inline-block', verticalAlign: 'middle' }}>
                            <CustomActionButton onClick={() => handleAddOption(index)} buttonText={'Add Option'} />
                          </div>
                            <div style={{display:'flex', flexDirection:'row',flexWrap:'wrap'}}>
                                {question.options.map((option, oIndex) => (
                                  <div key={oIndex} style={{alignItems:'baseline'}}>
                                  <TextField
                                    label={``}
                                    variant="standard"
                                    value={option}
                                    onChange={(e) => handleOptionChange(index, oIndex, e.target.value)}
                                    inputProps={{ minLength:5, maxLength: 30, }}
                                    helperText={option.length>0 && !isValidLength(option,5,30) ? `Length must be between 5 and 30 with no special characters allowed. ${option.length}/30 characters used` : `Length must be between 5 and 30 with no special characters allowed.${option.length}/30 characters used`}
                                    FormHelperTextProps={{
                                      sx : { color: !isValidLength(option,5,30) ? '#DC272D' : '#00943D' }
                                    }}
                                    sx={{
                                      width:"60px",
                                      marginLeft:"16px",fontSize:"16px",fontFamily:"Roboto",marginLeft:"14px",
                                      '& .MuiInputBase-input:focus': {
                                          color: '#008CD7',
                                      },
                                      '& .MuiInputBase-root': {
                                          fontFamily: 'Roboto',
                                          fontSize: '16px',
                                          fontWeight: '700',
                                          color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                      },
                                      '& .MuiInput-root .MuiInputBase-input': {
                                          
                                      },
                                      '& .MuiInputBase-root::before': {
                                          borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                                      },
                                      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                          borderBottom: '2px solid #008CD7',
                                      },
                                      '& .MuiInputBase-root::after': {
                                          borderBottom: '2px solid #008CD7',
                      
                                      },
                                    }} 
                                  />
                                  <Button sx={{ width:"20px",height:"20px",padding:"0px",fontSize:"16px",fontFamily:"Roboto",textTransform:'capitalize', backgroundColor:"var(--SecondaryBackground)", borderRadius:"20px", boxShadow: "none",marginTop:"14px"}} variant="text" onClick={() => handleRemoveOption(index, oIndex)} disableTouchRipple elevation={0}>
                                      <LK_Delete color={"#005C8E"} width={"20px"} height={"20px"}/>  
                                  </Button>
                                  </div>
                                ))}
                            </div>
                          
                          </div>
                      
                        )}
                    </div>
              </div>

            ))}
            <Dialog 
                open={qnasubmitted} 
                onClose={handleCloseQnA}
                BackdropProps={{
                    sx:{
                        backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                    }
                }}
                sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}>
                    <DialogTitle sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>{"Added to Save"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF"}}>
                            Added Question and Answer Template for saving
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{justifyContent:'center'}}>
                        <CustomCancelButton onClick={handleCloseQnA} buttonText={'Ok'}></CustomCancelButton>
                    </DialogActions>
            </Dialog> 
            <Dialog
                open={openAtLeastOneConditionDialog}
                onClose={handleCloseAtLeastOneConditionDialog}
                BackdropProps={{
                    sx:{
                        backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                    }
                }}
                sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}
            >
                <DialogTitle  sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>Single Condition</DialogTitle>
                    <DialogContent >
                        <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF"}}>
                            At least one question is required
                        </DialogContentText>
                    </DialogContent>
                <DialogActions sx={{justifyContent:'center'}}> 
                    <Button onClick={handleConfirmationAtLeastOneConditionDialog} sx={{ outline:'none !important',boxShadow:'none', height:'35px', width:'125px',fontSize: '16px',textTransform:'capitalize', marginRight:"5px",backgroundColor:"#005C8E", borderRadius:"20px"}} variant="contained" autoFocus>
                        Ok
                    </Button>
                    <CustomCancelButton width={"125px"} onClick={handleCloseAtLeastOneConditionDialog} buttonText={'Cancel'}></CustomCancelButton>
                </DialogActions>
            </Dialog>
            {/* Dialog for question limit */}
            <CustomDialogBox
              dialogTitle={"Selection of SOP QnA Format"}
              dialogText={"You cannot add more than 10 questions."}
              openDialog={openQuestionLimitDialog}
              handleCloseDialog={handleOpenQuestionLimitDialogClose}
              handleConfirmDialog={handleOpenQuestionLimitDialogClose}
              confirmText={"Ok"}
              cancelText={"Cancel"}
            />
            {/* Dialog for option limit */}
            <CustomDialogBox
              dialogTitle={"Selection of Options"}
              dialogText={"You cannot add more than 5 options."}
              openDialog={openOptionLimitDialog}
              handleCloseDialog={handleOpenOptionLimitDialogClose}
              handleConfirmDialog={handleOpenOptionLimitDialogClose}
              confirmText={"Ok"}
              cancelText={"Cancel"}
            />
        </div>
    </div>
    
  );
});

export default Questionnaire;
